import {PropsWithChildren, ReactElement, Suspense, lazy} from "react";

/*
 * React.lazy so the web3 chunk is code-split and only downloads when a wallet
 * surface actually mounts this boundary.
 */
const WalletProvider = lazy(() => import("@/components/wallet/WalletProvider"));

/*
 * Wraps a wallet surface — Stash redeem, Industry Pass management, GoVip / My
 * Rewards redeem — in the lazy WalletProvider so its thirdweb-dependent UI has
 * provider context and an auto-connected wallet. Feature pages import THIS (not
 * WalletProvider directly) so importing them never statically pulls thirdweb.
 * fallback is null: the wallet UI simply isn't interactive for the ~1s the chunk
 * loads, rather than blocking the whole page.
 */
export default function LazyWalletBoundary({children}: PropsWithChildren): ReactElement {
    return (
        <Suspense fallback={null}>
            <WalletProvider>{children}</WalletProvider>
        </Suspense>
    );
}
